import axios from "axios";
import { url } from "../config/url";
import { STORE_CREATE_FAIL, STORE_CREATE_REQUEST, STORE_CREATE_SUCCESS, STORE_DELETE_FAIL, STORE_DELETE_REQUEST, STORE_DELETE_SUCCESS, STORE_GET_FAIL, STORE_GET_REQUEST, STORE_GET_SUCCESS, STORE_LIST_FAIL, STORE_LIST_REQUEST, STORE_LIST_SUCCESS, STORE_UPDATE_FAIL, STORE_UPDATE_REQUEST, STORE_UPDATE_SUCCESS } from "../constants/storeConstants";


import { logout } from "./userActions";

export const createStore = (name, status) => async (dispatch, getState) => {
  try {
    dispatch({ type: STORE_CREATE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(
      `${url}/stores`,
      { name, status },
      config
    );
    dispatch({
      type: STORE_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STORE_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listStores = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: STORE_LIST_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${url}/stores`, config);

    dispatch({
      type: STORE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    console.log(message);

    dispatch({
      type: STORE_LIST_FAIL,
      payload: message,
    });
  }
};

export const getStore = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: STORE_GET_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${url}/stores/${id}`, config);

    dispatch({
      type: STORE_GET_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    console.log(message);

    dispatch({
      type: STORE_GET_FAIL,
      payload: message,
    });
  }
};

export const updateStore = (store) => async (dispatch, getState) => {
  try {
    dispatch({ type: STORE_UPDATE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(
      `${url}/stores/${store._id}`,
      store,
      config
    );
    dispatch({
      type: STORE_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: STORE_UPDATE_FAIL,
      payload: message,
    });
  }
};

export const deleteStore = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: STORE_DELETE_REQUEST,
    });
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    await axios.delete(`${url}/stores/${id}`, config);
    dispatch({
      type: STORE_DELETE_SUCCESS,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: STORE_DELETE_FAIL,
      payload: message,
    });
  }
};
